"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
exports.renderOverflowButton = function (overflowItems) {
    return (react_1.default.createElement(react_2.CommandBarButton, { role: "menuitem", menuIconProps: { iconName: 'More' }, menuProps: {
            items: overflowItems !== null && overflowItems !== void 0 ? overflowItems : [],
        } }));
};
//# sourceMappingURL=LayoutCommandOverflowButton.js.map